// extracted by mini-css-extract-plugin
export default {"rowContainer":"Notifications_rowContainer__UcD4U"};